import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import INSTRUCTOR_CREATE from '../mutations/INSTRUCTOR_CREATE';

const useInstructorCreate = () => {
    const [ createNewInstructor ] = useMutation( INSTRUCTOR_CREATE );

    const createInstructor = async ( saveData ) => {
        try {
            const response = await createNewInstructor( { variables: { input: saveData } } );
            const success = response?.data?.createInstructor;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating instructor', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createInstructor         
        };
    }, [] );
};

export default useInstructorCreate;
